<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <h1>{{ $t('menu.general-member') }}</h1>
            <piaf-breadcrumb />
            <div class="separator mb-5" />
        </b-colxx>
    </b-row>

    <b-row class="mb-5">
        <b-colxx xxs="12">
            <b-card class="mb-4">
                <b-row>
                    <b-colxx xxs="12" md="4" lg="3" xl="3" class="pr-0">
                        <v-select :options="searchOptions" v-model="searchKind"></v-select>
                    </b-colxx>
                    <b-colxx xxs="12" md="6" lg="4" xl="4">
                        <b-input-group class="mb-3">
                            <b-input v-model="searchKeyword" @keyup.enter="onSearch" /><!-- :placeholder="$t('menu.search')" -->
                            <b-input-group-append>
                                <b-button variant="outline-primary default" v-show="!searchFlag" @click="onSearch">
                                    {{$t('button.search')}}
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-colxx>
                </b-row>

                <template v-if="isLoad">
                    <b-table head-variant="light" ref="general-table" class="vuetable" selectedVariant="primary" :items="content" :fields="fields" primary-key="settingId" responsive show-empty>
                        <template v-slot:cell(username)="row">
                            <router-link :to="`general-detail/${row.item.username}`" class="cls_click">
                                {{row.item.username}}
                            </router-link>
                        </template>
                        <template v-slot:cell(registeredDate)="row">
                            {{row.item.registeredDate.substr(0,10)}}
                        </template>

                        <template v-slot:empty>
                            <h4 style="text-align:center">조회된 내용이 없습니다.</h4>
                        </template>

                    </b-table>
                    <b-pagination v-if="lastPage > 1" size="sm" align="center" :total-rows="total" :per-page="pageSize" v-model="pageNumber">
                        <template v-slot:next-text>
                            <i class="simple-icon-arrow-right" />
                        </template>
                        <template v-slot:prev-text>
                            <i class="simple-icon-arrow-left" />
                        </template>
                        <template v-slot:first-text>
                            <i class="simple-icon-control-start" />
                        </template>
                        <template v-slot:last-text>
                            <i class="simple-icon-control-end" />
                        </template>
                    </b-pagination>

                </template>
                <template v-else>
                    <div class="loading"></div>
                </template>

            </b-card>
        </b-colxx>
    </b-row>

</div>
</template>

<script>
import api from '../../constants/api'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import '../../assets/css/custom/common.css'
import {
    alignTableCenter
} from '../../utils'

import {
    mapGetters,
    mapActions
} from "vuex";

export default {
    components: {
        'v-select': vSelect
    },
    data() {
        return {
            storeCodeLoad: false,
            isLoad: false,
            brandStoreCode: [],
            searchKind: {
                label: '전체',
                value: 'NoKeyword'
            },
            searchOptions: [{
                    label: '전체',
                    value: 'NoKeyword'
                },
                {
                    label: '사용자 ID',
                    value: 'Username'
                },
                {
                    label: '이메일',
                    value: 'Email'
                },
                {
                    label: '사용자 이름',
                    value: 'FullNameContaining'
                },
                {
                    label: '전화번호',
                    value: 'PhoneNumber'
                },
                {
                    label: '전화번호 끝 4자리',
                    value: 'PhoneNumber4'
                },
            ],
            fields: [{
                    key: 'key',
                    label: '번호',
                    ...alignTableCenter
                },
                {
                    key: 'Username',
                    label: '아이디',
                    ...alignTableCenter
                },
                {
                    key: 'email',
                    label: '이메일',
                    ...alignTableCenter
                },
                {
                    key: 'fullName',
                    label: '이름',
                    ...alignTableCenter
                },
                {
                    key: 'registeredDate',
                    label: '등록일'
                },
            ],
            searchFlag: false,
            selectedMemberId: null,
            currentPage: 1,
            perPage: 10,
            searchKeyword: '',
            total: 15,
            lastPage: 1,
            pageNumber: 0,
            pageSize: 20,
            content: [],
            totalPages: 0, //전체 페이지 수
            totalElements: 0, //전체 아이템 수
            numberOfElements: 0, //현재 조회된 아이템 수
            first: true, //첫 페이지일 경우 true
            last: false, //마지막 페이지일 경우 true
            keywordType: "NoKeyword",
        }
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {
        console.log(this.pageNumber)
        this.searchData()
    },
    watch: {

    },
    methods: {

        //운영자 리스트 조회
        searchData() {
            var vm = this
            this.content = []
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.generalList)
            
            const params = {
                keywordType: this.searchKind.value,
                keyword: this.searchKeyword,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
            }

            console.log(params)

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    this.content = res.data.data.content;
                    this.totalPages = res.data.data.totalPages; //전체 페이지 수
                    this.totalElements = res.data.data.totalElements; //전체 아이템 수
                    this.numberOfElements = res.data.data.numberOfElements; //현재 조회된 아이템 수
                    this.content.forEach((value, index) => {
                        value.key = index + 1;
                    });
                } else {
                    this.content = [];
                    this.totalPages = 0; //전체 페이지 수
                    this.totalElements = 0; //전체 아이템 수
                    this.numberOfElements = 0; //현재 조회된 아이템 수
                }
            }).catch(err => {
                this.content = [];
                this.totalPages = 0; //전체 페이지 수
                this.totalElements = 0; //전체 아이템 수
                this.numberOfElements = 0; //현재 조회된 아이템 수
            })
            this.isLoad = true

        },

        
        onSearch() {
            if (this.searchKeyword === "" && this.searchKind.label !== '전체' && this.searchOptions.label !== '전체') {
                alert('검색어를 입력하세요');
                return false
            }
            // this.searchFlag = true;
            this.searchData();
        },
        searchCancel() {
            this.searchFlag = false;
            this.searchKeyword = '';
            this.searchData();
        },
        changePageSize(perPage) {
            this.perPage = perPage
        },
        changedItemCheck(row) {
            console.log(row)
        }
    }
}
</script>
